import { render, staticRenderFns } from "./BlogEditor.vue?vue&type=template&id=0b8f13ae&scoped=true&"
import script from "./BlogEditor.vue?vue&type=script&lang=js&"
export * from "./BlogEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlogEditor.vue?vue&type=style&index=0&id=0b8f13ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f13ae",
  null
  
)

export default component.exports